const state = {
  notFound: false,
  navigationDrawer: false,
  snackbar: {},
  dialog: {},
  progress: [],
  brand: null,
  filters: null,
  manageAutomatedTasks: null,
  manageAutomatedTasksUnsubscribe: () => {},
  manageCompanies: null,
  manageCompaniesUnsubscribe: () => {},
  manageOperators: null,
  manageOperatorsUnsubscribe: () => {},
  user: null,
  userSubstitute: null,
  plan: null,
  planUnsubscribe: () => {},
  loading: false,
  maintenanceMode: false,
  navigationPages: {},
  news: [],
  newsUnsubscribe: () => {},
  notifications: [],
  notificationsUnsubscribe: () => {},
  signatures: [],
  signaturesUnsubscribe: () => {},
  notificationsListOptions: {},
  notificationsSearch: '',
  notificationsAdvancedSearch: '',
  notificationsCurrentPeriod: '',
  notificationNav: {
    ids: [],
    index: -1,
  },
  signaturesListOptions: {},
  signaturesSearch: '',
  localAppVersion: process.env.VUE_APP_VERSION,
  remoteAppVersion: '',
  contractModel: '',
  arrayListener: [],
  pending: {},
  msalInstance: null,
  externalAuthConfig: null,
  unregisteredNotificationsReload: 0,
  massiveActionsSettings: {},
}

export default state
